/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Inbox_BannerInputs */

const en_inbox_banner = /** @type {(inputs: Inbox_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} new recipe suggestions from friends`)
};

const de_inbox_banner = /** @type {(inputs: Inbox_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} neue Rezeptvorschläge von Freunden`)
};

/**
* | output |
* | --- |
* | "{count} new recipe suggestions from friends" |
*
* @param {Inbox_BannerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const inbox_banner = /** @type {((inputs: Inbox_BannerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_BannerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_inbox_banner(inputs)
	return en_inbox_banner(inputs)
});